<template>
  <div class="home">
    <div class="container">
      <div class="dep"  @click.prevent="preJob">
        <div class="optc">
          <span>预约业务：</span>
          <input type="text" placeholder="请先选择预约业务" v-model="job" readonly  @blur="allDown" @focus="allTop">
        </div>
      </div>
      <div class="dep"  @click.prevent="preThing" v-if="showthing">
        <div class="optc">
          <span>预约事项：</span>
          <input type="text" placeholder="请先选择预约事项" v-model="thing" readonly  @blur="allDown" @focus="allTop">
        </div>
      </div>
      
      <!-- 查询等待人数 -->
      <div class="box" v-if="showmsg">
        <p>当前等待人数：<span>{{sucResult.waitNum}}</span>&nbsp;人</p>
      </div>
    
      <div @click="pre" :class="{ isSubmit: isPre, unSubmit: !isPre}"><span>查询等待人数</span></div>

      <div class="myPicker" v-show="pickerView">
        <van-picker show-toolbar
            :title="title"
            :columns="columns"
            @cancel="onCancel"
            @confirm="onConfirm" />
      </div>
    </div>
  </div>
</template>
<script>

import { Toast, Dialog } from 'vant'
import { request } from '../network/request'
import { getMsg } from '../tools/get'

export default {
  data() {
    return {
      showthing: false,   // 显示事项
      showmsg: false,     // 显示等待人数

      job: "",            // 预约业务
      joblist: [],        // 业务
      jobArr: [],         // 业务源
      jobid: [],          // 业务 id项
      job_id: [],         // 业务 id

      thing: "",          // 预约事项
      thinglist: [],      // 事项
      thingArr: [],       // 事项源
      thingid: [],        // 事项 id项
      thing_id: "",       // 事项 id

      columns: [],        // picker 选项
      pickerView: false,  // picker 默认隐藏
      isPre: true,        // 查询等待人数
      isWho: 1,           // 判断是谁启动的弹出框
      pre2: false,        // 事项是否可选
      jobVar: "",         // 是否改变
      thingVar: "",       // 是否改变
      title: '',          // picker 信息为空
      t: null,            // 回调函数
      sucResult: {}       // 返回结果 传值
    }
  },

  created() {
    this.hallData();
  },

  methods: {

    allDown(){ this.t = setTimeout( ()=>{ (document.body.scrollTop = 0) || (document.documentElement.scrollTop = 0); }, 250) }, // input 失去焦点，回退底部
    allTop(){ clearTimeout( this.t ) },
    
    // 请求接口获取初始化数据
    hallData() {
      var url = '';
      var obj = {
                 "cmd":"initialization"
               };
       getMsg(url, obj).then(result=>{

          console.log('响应 - 成功')
          console.log(result)

          if(result.status == 200) {

            if(result.data.result == 0) {

              console.log(result.data)
              var list = result.data.data;

              for(var i = 0; i < list.length; i++){

                this.joblist.push(list[i].bussName);      // 4. 业务列表
                this.jobid.push(list[i].bussTypeId);      // 业务 id项
                this.thingArr.push(list[i].bussItem);     // 5. 业务事项
              }
            }
          }
       })
    },

    // 获取业务列表
    preJob(){

        console.log('业务列表：' + this.joblist);
        if(this.joblist.length == 0){
          Dialog.alert({ title: '提示', message: "没有获取到数据，请重新进入程序"}).then(() => {
            document.addEventListener('WeixinJSBridgeReady', function(){ WeixinJSBridge.call('closeWindow'); }, false) || WeixinJSBridge.call('closeWindow');  // 退出微信网页
          });
        }else{
          this.title = '选择预约业务';       // picker 信息
          this.columns = this.joblist;      // picker 选项
          this.pickerView = true;           // picker 显示
          this.isWho = 1;                   // 判断谁启动的弹窗
        }
    },

    // 获取事项列表
    preThings(){

      if(this.pre2){
        var arrthing = [];
        for(var i = 0; i < this.joblist.length; i++){
          if(this.job == this.joblist[i]){
            arrthing = this.thingArr[i];
          }
        }

        this.thinglist = [];
        this.thingid = [];
        for(var j = 0; j < arrthing.length; j++){
            this.thinglist.push(arrthing[j].ItemName);    // 事项
            this.thingid.push(arrthing[j].bussItemId);    // 事项 id项 
        }

        if(this.thinglist.length == 0){
          console.log("----- 有没有事项 -----");
          this.showthing = false;
        }
        else{
          this.showthing = true;
        }
      }
    },

    preThing(){
        this.title = '选择预约事项';      // picker 信息
        this.columns = this.thinglist;
        this.pickerView = true;         // popup 显示
        this.isWho = 2;                 // 判断谁启动的弹窗
    },

     onConfirm(value, index){
       if(this.isWho == 1){        // 1. 选择业务

        this.job = value;         // 选中业务赋给 input

        if(this.jobVar != this.job){

          this.jobVar = this.job;

          this.thing = "";      // 2. 清除
        }
        if( this.job != ""){ this.pre2 = true; }  //激活下一个按钮图片
          this.preThings()
      }else if (this.isWho == 2) {                //2. 选择事项

        this.thing = value;

        if(this.thingVar != this.thing){

          this.thingVar = this.thing;
        }
      }
      this.pickerView = false;
     },

     onCancel(){ this.pickerView = false; },

     // 查询按钮 -- 查询预约等待人数
     pre(){

        if((this.job != "" && this.showthing == false)||(this.thing != "" && this.job != "")){
             for(var i = 0; i < this.jobid.length; i++){
              if(this.job == this.joblist[i]){
                this.job_id = this.jobid[i];
              }
            }

            for(var j = 0; j < this.thingid.length; j++){
              if(this.thing == this.thinglist[j]){
                this.thing_id = this.thingid[j];
              }
            }
        this.reqData()
      }
      else {
        Toast('请先完善信息')
      }
    },

    // 点击查询按钮之后调用接口查询预约等待人数
    // 
    reqData() {
      var url = '';
      var obj = {
                  "cmd": "querywaitinum",
                  "bussTypeId": this.job_id,
                  "bussItemId": this.thing_id
              }
      getMsg(url, obj).then(result => {

        console.log('查询等待人数 - 接到响应')
        console.log(result)
        if(result.status == 200){
          if(result.data.result == 0) {
            this.sucResult = {                                  // 查询成功 响应结果
                              "waitNum": result.data.waitNum,   // 等待人数
                              "bussTypeName": this.job,         // 预约业务
                              "bussItemName": this.thing        // 预约事项
                             };

                            // 下次查询之前清空上一次的查询记录，防止出现重复错误
                            this.job_id = "";
                            this.thing_id = "";
                            this.showmsg = true;               // 显示预约人数
            console.log(this.sucResult)
          }
          else if(result.data.status == 301) { Toast(result.data.errdesc); console.log('行为不存在') }
          else if(result.data.status == 302) { Toast(result.data.errdesc); console.log('数据库操作失败') }
          else if(result.data.status == 303) { Toast(result.data.errdesc); console.log('用户没有登录') }
          else if(result.data.status == 305) { Toast(result.data.errdesc); console.log('参数错误') }
          else if(result.data.status == 304) { Toast(result.data.errdesc); console.log('网站黑名单') }
          else if(result.data.status == 306) { Toast(result.data.errdesc); console.log('数据不存在') }
          else if(result.data.status == 307) { Toast(result.data.errdesc); console.log('当前条件下不符合要求') }
          else { Toast(result.data.errdesc); console.log('请求失败') }
        }
        else {
          Toast("网络错误")
          console.log(result.status)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  *{
    color: #666;
    font-family: Microsoft YaHei;
  }

  input::placeholder{
    color:#aaa;
  }

  body::-webkit-scrollbar{
    overflow-y: hidden;
  }

  .home{
    width:100%;
  }

  .container{
    width: calc(100% - 20px);
    padding: 0 10px 50px 10px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
  }

  /* 1. 预约业务、预约日期、预约时段 */
  .dep{
    width: calc(100% - 2px);
    border-radius: 3px;
    background:#fff;
    margin-top:5px;
  }

  .optc{
    width: 100%;
    height: 40px;
    background: url(../assets/bt.png) no-repeat 8px center;
    background-size: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .optc>span{
    margin-left: 18px;
    width: 76px;
  }

  .optc>input{
    width: calc(100% - 94px);
    outline: none;
    border: none;
     border-radius: 3px;
  }

  .myPicker{
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    box-shadow: -2px 0 10px 2px #BBB;
  }

  /* 3. 预约取票 */
  .unSubmit{
    width: 100%;
    height: 48px;
    border-radius: 24px;
    line-height: 48px;
    text-align: center;
    margin-top: 20px;
    background: #a0a0a0;
  }

  .isSubmit{
    width: 100%;
    height: 48px;
    border-radius: 24px;
    line-height: 48px;
    text-align: center;
    margin-top: 20px;
    background-image: linear-gradient(to bottom,#0984e4,#15b8f2);
  }

  .isSubmit>span{
    font-size: 16px;
    color: #fff;
  }

  .unSubmit>span{
    font-size: 16px;
    color: #fff;
  }

  .box {
     width: calc(100% - 2px);
     margin-top: 5px;
  }

  .box>p{
    padding-left: 10px;
    font-size: 16px;
  }

  .box>p>span{
    font-size: 16px;
    color: #ff0000;
    font-weight: bold;
  }
</style>